export const environment = {
  production: false,
  apiUrl: 'https://dev.api.ourdigimenu.com',
};
